import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { IModal, UserRoleEnum } from "../../stores/index.d";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";

const UserForm = observer(({ show, setShowModal }: IModal) => {
  const { userStore } = useStores();
  const { editUser, fetchUsers, updateUser, createUser } = userStore;
  const [user, setUser] = useState<IUserCommand>(
    editUser ?? {
      id: "",
      email: "",
      firstName: "",
      surname: "",
      phoneNumber: "",
      password: "",
      callbackUrl: "",
      roles: [UserRoleEnum.ShopUser],
    }
  );
  const [isFormValid, setIsFormValid] = useState(false);
  const isEditRequest = editUser != null && editUser.id != null;

  const validateForm = () => {
    const isValid =
      user.email &&
      user.firstName &&
      user.surname &&
      user.phoneNumber &&
      (isEditRequest || user.password)
        ? true
        : false;

    setIsFormValid(isValid);
  };

  useEffect(() => {
    validateForm();
  }, [user]);

  const submitCallback = useCallback(
    (res: boolean) => {
      if (res) {
        setShowModal(false);
        fetchUsers();
      }
    },
    [fetchUsers, setShowModal]
  );

  const handleFormSubmit = () => {
    if (!isFormValid) {
      ShowAlert.Error("One or more field value missing.");
      return;
    }

    if (user.id) updateUser(user as IUserCommand, submitCallback);
    else createUser(user as IUserCommand, submitCallback);
  };

  const handleInputChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = evt.target;
    setUser((prev) => ({ ...prev, [id]: value }));
  };

  return (
    <Modal show={show} onHide={() => setShowModal(false)}>
      <ModalHeader closeButton>
        <Modal.Title>
          <h5>{isEditRequest ? "Update" : "Add"} User</h5>
        </Modal.Title>
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="firstName"
              placeholder="First Name"
              value={user.firstName}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="firstName">First Name</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="surname"
              placeholder="surname"
              value={user.surname}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="surname">Surname</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="email"
              placeholder="email"
              value={user.email}
              required
              disabled={isEditRequest}
              onChange={handleInputChange}
            />
            <label htmlFor="email">Email</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="phoneNumber"
              placeholder="Contact Number"
              value={user.phoneNumber}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="phoneNumber">Phone Number</label>
          </div>
          {!isEditRequest && (
            <>
              <div className="form-floating">
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="Password"
                  value={user.password}
                  onChange={handleInputChange}
                />
                <label htmlFor="password">Password</label>
              </div>
              <div className="small text-muted">
                *minimum 6 characters length
              </div>
            </>
          )}
        </form>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-default flex-fill"
          onClick={handleFormSubmit}
          disabled={!isFormValid}
        >
          {isEditRequest ? (
            <>
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              <span>Update User Details</span>
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              <span>Add User</span>
            </>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
});

export default UserForm;
